import { render, staticRenderFns } from "./AuditsCrons.vue?vue&type=template&id=54b35ef7"
import script from "./AuditsCrons.vue?vue&type=script&lang=ts"
export * from "./AuditsCrons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports